import types from './RequestPriorityType';

/**
 * Цвет метки приоритета: текст и фон. Контраст текста к фону — не ниже 4.5:1, чтобы
 * метка читалась и без различения цвета.
 */
export default class RequestPriorityColor {
    static [types.CRITICAL] = { color: '#b3261e', background: '#fde7e5' };
    static [types.HIGH] = { color: '#9a4a00', background: '#fdebd7' };
    static [types.NORMAL] = { color: '#3c4a57', background: '#eaeef2' };
    static [types.LOW] = { color: '#4f5b66', background: '#f3f5f7' };
}
